import React, { createContext, useContext, useState } from "react";
import PropTypes from "prop-types";
import { API_DOMAIN_URL } from "../Common";
import { PAGE_PATH } from "../Common";

export const UserContext = createContext();
export const useUser = () => useContext(UserContext);

export default function UserProvider({ children }) {
  const [user, setUser] = useState();

  const deleteCookies = () => {
    var cookies = document.cookie;
    var cookiesArray = cookies.split(";");
    for (var c of cookiesArray) {
      var cArray = c.split("=");
      if (cArray[0].indexOf("hacaro") != -1) {
        document.cookie =
          cArray[0].trim() + "=;max-age=0 path=/" + PAGE_PATH + ";";
        document.cookie = cArray[0].trim() + "=;max-age=0 path=/;";
      }
    }
  };

  const loginUser = (userName = "", password = "") => {
    const code = process.env.REACT_APP_API_CODE;
    const url = API_DOMAIN_URL + `/api/App_WebLogin?code=${code}`;

    fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ UserName: userName, Password: password }),
    })
      .then((response) => {
        if (!response.ok) throw new Error("Unauthorized");
        return response.json();
      })
      .then((response) => {
        const cookieValidSeconds = 60 * 60;
        document.cookie =
          `hacaroUserId=${response.id}; max-age=${cookieValidSeconds}`.trim();
        document.cookie =
          `hacaroUserName=${userName}; max-age=${cookieValidSeconds}`.trim();
        document.cookie =
          `hacaroWebToken=${response.WebToken}; max-age=${cookieValidSeconds}`.trim();
        setUser(response);
      })
      .catch(() => {
        let errorUser = {};
        errorUser.id = "error";
        setUser(errorUser);
        deleteCookies();
      });
  };

  const resumeSession = (userName = "", webToken = "") => {
    const code = process.env.REACT_APP_API_CODE;
    const url =
      API_DOMAIN_URL +
      `/api/App_ValidateWebToken?code=${code}&UserName=${userName}&WebToken=${webToken}`;

    fetch(url)
      .then((response) => {
        if (!response.ok) throw new Error("Unauthorized");
        return response.json();
      })
      .then((response) => {
        const cookieValidSeconds = 60 * 60;
        document.cookie =
          `hacaroUserId=${response.id}; max-age=${cookieValidSeconds}`.trim();
        document.cookie =
          `hacaroUserName=${userName}; max-age=${cookieValidSeconds}`.trim();
        document.cookie =
          `hacaroWebToken=${webToken}; max-age=${cookieValidSeconds}`.trim();
        setUser(response);
      })
      .catch(() => {
        let errorUser = {};
        errorUser.id = "error";
        setUser(errorUser);
        deleteCookies();
      });
  };

  const logoutUser = (webToken = "") => {
    deleteCookies();
    setUser(null);

    const code = process.env.REACT_APP_API_CODE;
    const url = API_DOMAIN_URL + `/api/App_WebLogout?code=${code}`;

    fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ WebToken: webToken }),
    });
  };

  return (
    <UserContext.Provider
      value={{ user, setUser, loginUser, resumeSession, logoutUser }}
    >
      {children}
    </UserContext.Provider>
  );
}

UserProvider.propTypes = {
  children: PropTypes.any,
};
